import { memo, useRef } from 'react';
import { canvasCls } from './_tool.style.js';
import { useDrawHandler } from './hook.draw-handler.js';
import { jsx } from 'react/jsx-runtime';

const DrawLineToolUnmemoized = props => {
  const internalRef = useRef(null);
  const ref = props.ref ?? internalRef;
  useDrawHandler(props.pageId, ref);
  return /*#__PURE__*/jsx("canvas", {
    ref: ref,
    className: canvasCls
  });
};
const DrawLineTool = /*#__PURE__*/memo(DrawLineToolUnmemoized);

export { DrawLineTool, DrawLineToolUnmemoized };
//# sourceMappingURL=_tool.js.map
